import { clamp, finiteOr } from "../physics/numbers";
import type { GameConfig, VehicleDynamics } from "./types";

export const FIXED_STEP = 1 / 120;

export const DEFAULT_GAME_CONFIG: GameConfig = {
  fixedStep: FIXED_STEP,
  countdownDuration: 3,
  totalLaps: 3,
  trackLength: 1_770.6,
  roadHalfWidth: 8.15,
  initialBestLapTime: null
};

export const createVehicleDynamics = (
  gameConfig: Pick<GameConfig, "trackLength" | "roadHalfWidth">,
  overrides: Partial<VehicleDynamics> = {}
): VehicleDynamics => ({
  trackLength: gameConfig.trackLength,
  roadHalfWidth: gameConfig.roadHalfWidth,
  maximumSpeed: 90,
  boostedMaximumSpeed: 102,
  engineAcceleration: 18.5,
  brakeDeceleration: 31,
  rollingResistance: 1.1,
  aerodynamicDrag: 0.00195,
  boostAcceleration: 17,
  boostConsumption: 0.38,
  boostHeatRate: 0.34,
  boostCoolingRate: 0.24,
  steeringResponse: 4.8,
  steeringReturn: 6.2,
  driftChargeRate: 0.58,
  driftChargeDecay: 0,
  ...overrides
});

export const resolveGameConfig = (overrides: Partial<GameConfig> = {}): GameConfig => {
  const merged = { ...DEFAULT_GAME_CONFIG, ...overrides };
  const initialBestLapTime = merged.initialBestLapTime;

  return {
    fixedStep: clamp(finiteOr(merged.fixedStep, FIXED_STEP), 1 / 1_000, 0.1),
    countdownDuration: clamp(finiteOr(merged.countdownDuration, 3), 0, 10),
    totalLaps: clamp(Math.round(finiteOr(merged.totalLaps, 3)), 1, 99),
    trackLength: clamp(finiteOr(merged.trackLength, 1_770.6), 1, 100_000),
    roadHalfWidth: clamp(finiteOr(merged.roadHalfWidth, 8.15), 0.5, 100),
    initialBestLapTime:
      initialBestLapTime !== null &&
      Number.isFinite(initialBestLapTime) &&
      initialBestLapTime > 0
        ? initialBestLapTime
        : null
  };
};
